// Author: sametbayat
// Dec 29, 2023 10:23 AM


import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function About() {
    const size = 150;
    return (
        <div className={'container'}>
            <h2>About Me</h2>

            <div className="row">
                <div className="col">
                    <h3>Sam</h3>
                    <img className="img-fluid rounded-circle" style={{ width: size, height: size }} src="sam_profile.png" alt="Sam's Profile" />
                    <p>
                        Hi, I'm Sam! I have a passion for technology and love creating innovative solutions.
                        My background in software development allows me to bring ideas to life in the digital world.
                        <br/>
                        PS: Of course, I'm a FilmBuff!
                    </p>
                </div>
            </div>

        </div>
    );
}

export default About;
